import { Grid, useMediaQuery } from '@mui/material';
import React, { useContext, useState } from 'react'
import globalStyles from "../../../../../assets/styles/global.module.scss";
import textStyles from "../../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss"
import styles from "../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss"
import workflowStyles from "../../../../../assets/styles/componentStyles/workflowStyles/workflowStyle.module.scss";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import GlobalPopUp from '../../../../utility/globalPopUp';
import ResetVariablePopup from './resetVariable/resetVariablePopup';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext';
import { useFlowBuilderStore } from '../../../../../store/flowBuilderStore';

const ResetVariableFormComponent = (props: any) => {

    const { actionData, stepAction } = props;
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 900px)'); 
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)
    const { onChangeCurrentActiveNodeConfig, nodes, setNodes, onBlurOfFallBackOfBtnVar, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload

    const [resetVariablePopup, setResetVariablePopup] = useState<boolean>(false);
    
    const storeBackupValue = () => {
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
            { type: "store_backup_value" },
            {
                updateType: "editExistingStepAction"
            }
        )
    } 

    const handleCancelClick = () => {
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
            { type: "cancel_changes" },
            {
                updateType: "editExistingStepAction"
            }
        ); 
        setResetVariablePopup(false);
    } 

    const getValueOfResetVariableText = () => { 
        if(!actionData.flag_reset_all_custom_variable && actionData?.reset_custom_variable?.length == 0){
            return "Please configure reset variable";
        } else {
            return (
                <span>
                    {actionData.flag_reset_all_custom_variable ? 
                        "Reset All Variable" 
                        : 
                        customVariableList?.custom_variable_data?.filter((variable) => actionData?.reset_custom_variable?.find((resetVar: any) => resetVar?.reset_custom_variable_id == variable.chatbot_custom_variable_configuration_id))?.map((variable) => variable?.chatbot_custom_variable_name)?.join(", ")
                    }
                </span>
            );
        }
    }

    return (
        <>
            <Grid item>
                <Grid container direction={"column"} gap={"12px"}>
                    <Grid item mt={2} className={textStyles.templatesContainer}>
                        <Grid container direction={"column"} gap={"8px"} flexWrap={"nowrap"}>
                            <Grid item className={`${styles.bodyFormHeadingStyle} ${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`}>
                                Reset Data
                            </Grid>
                            <Grid item className={`${styles.contentBlockSubHeadingStyle} ${workflowStyles.resetVariableText}`}>
                                <Grid container gap={1} justifyContent={"space-between"} flexWrap={"nowrap"} alignItems={"center"}>
                                    <Grid item className={globalStyles.wordBreakBreakWord}>
                                        {getValueOfResetVariableText()}
                                    </Grid>
                                    <Grid item>
                                        <ModeEditIcon className={styles.editActionIcon} onClick={() => { setResetVariablePopup(true); storeBackupValue();}} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {resetVariablePopup &&
                    <GlobalPopUp
                        open={resetVariablePopup}
                        onClose={() =>  handleCancelClick()}
                        flagBackdrop
                        paperMinWidth={flagSmallScreen ? "280px" : "650px"}
                        paperMaxwidth={flagSmallScreen ? "580px" : "650px"}
                        flagShowCloseIcon={true}
                        // height={"100%"}
                        titlePadding='0'
                        handleClose={() =>handleCancelClick()}
                    >
                        <ResetVariablePopup actionData={actionData} stepAction={stepAction} setResetVariablePopup={setResetVariablePopup} handleCancelClick={handleCancelClick} />
                    </GlobalPopUp>
                }
            </Grid>
        </>
    )
}

export default ResetVariableFormComponent
